export const PAN_FUNDS = 'PAN_FUNDS';
export const PAN_FUNDS_SUCCESS = 'PAN_FUNDS_SUCCESS';
export const PRE_LOGIN_TRANSMISSION = 'PRELOGIN_TRANSMISSION';
export const PRE_LOGIN_TRANSMISSION_SUCCESS = 'PRELOGIN_TRANSMISSION_SUCCESS';

export const GET_DEPOID_SUCCESS = 'GET_DEPOID_SUCCESS';
export const GET_DEPOID = 'GET_DEPOID';

export const SUBMIT_DEPOID_SUCCESS = 'SUBMIT_DEPOID_SUCCESS';
export const SUBMIT_DEPOID = 'SUBMIT_DEPOID';
